import { useState } from "react";
import { useTasks } from "../Tasks";

const AddTask = () => {
  const [taskText, setTaskText] = useState("");
  const { addTask } = useTasks();

  const onChange = (e) => {
    setTaskText(e.target.value);
  };

  const enter = (e) => {
    if (e.key === "Enter") {
      if (taskText !== "") {
        addTask(taskText);
        setTaskText("");
      }
    }
  };

  const add = () => {
    if (taskText !== "") {
      addTask(taskText);
      setTaskText("");
    }
  };

  return (
    <section id="add-task">
      <input
        type="text"
        id="new-task-text"
        name="new-task"
        placeholder="New task..."
        onChange={onChange}
        onKeyPress={enter}
        value={taskText}
      ></input>
      <button id="new-task-btn" onClick={add}>
        Add
      </button>
    </section>
  );
};

export default AddTask;
